import cloneDeep from 'lodash.clonedeep'

export default function StoreReset({ store }) {
  const initialState = cloneDeep(store.$state)
  store.$reset = () => 
  {
    store.$patch(cloneDeep(initialState));
  }
}